import { useState } from "react";
import './sidebar.css';

export const Sidebar =  (props) => {
    const {states, expanded, selectState, selectedState} = props;
    return <div id="sidebar" className={expanded ? "expanded" : ""}>
        {expanded && <div id="sidebar-list">
            {Object.keys(states).map(stateName => {
                const isUpcoming = states[stateName].upcoming;
                return <div key={stateName} className={`sidebar-element ${selectedState === stateName ? 'selected' : ''} ${isUpcoming ? 'upcoming' : ''}`} onClick={() => !isUpcoming && selectState(stateName)}>
                    <h3>{stateName}</h3>
                </div>
            })}
        </div>}
    </div>
}

export default Sidebar;